import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../SectionsHeading";
import {
  GradiantDiv,
  Image,
  OuterGradiantDiv,
  SecondGradiantDiv,
} from "../../../Styles/style";
import Paragraph from "../../Paragraph";

const GridWraper = styled(Grid)`
  width: 100%;
  height: 100%;
  display: flex;
  /* flex-direction:column; */
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  column-gap: 24px;
`;
const ContinerWraper = styled(Container)`
  background: #050C24;
  height: auto;
  width: 100%;
  padding: 0 !important;
`;
const GridItem = styled(Grid)`
margin: 24px 0;
    @media(max-width:899px){
        
    }
    & .marginDiv{
        background: #070F29;
    }
    :hover{
        & .marginDiv{
            background: linear-gradient(to top, #fff, transparent);
    }
    }
`
const GridEmpty = styled(Grid)`
    @media(max-width:899px){
        display: none;
    }
`
const ContractDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent;
    font-size: 12px;
    border-radius: 24px;
    font-family: PoppinsR;
    margin:  4px 0;
    color:#fff;
    border: ${props => props.b ? props.b : "2px solid #fff"};
    transition: .5s;
    padding: 0 10px;
    @media(max-width:599px){
      font-size: ${props=> props.fs599};
  }

`
const TokenomicsSection = () => {
  return (
    <ContinerWraper maxWidth="xxl"  id="tokenomics">
      <Container>
        <GridWraper container>
          <Grid item xs={12}> 
            <SectionsHeading ta="center" data-aos="zoom-in">Tokenomics</SectionsHeading>
          </Grid>
          <GridEmpty item xs={3}>
          </GridEmpty>
          <GridItem  item xs={10} sm={6} md={3}  data-aos="fade-up">
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv p="10px 50px">
                    <Paragraph ta="center"  fm="PoppinsSB">
                Supply
                  </Paragraph>
                  <Paragraph ta="center" fs="24px"  fm="PoppinsSB">
                TBA
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridEmpty item xs={3}>
          </GridEmpty>
          <GridItem item xs={10} sm={6} md={3}  data-aos="fade-up">
            <OuterGradiantDiv  className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv p="10px 50px">
                    <Paragraph ta="center"   fm="PoppinsSB">
                Symbol
                  </Paragraph>
                <Paragraph ta="center" fs="24px"  fm="PoppinsSB">
                MOONRACER
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridEmpty  className="grid" item xs={10} sm={6} md={3}>
              <Image data-aos="zoom-in" w="100%" src="./Images/tekenimage.png"/>
          </GridEmpty>
          <GridItem item xs={10} sm={6} md={3}  data-aos="fade-up">
            <OuterGradiantDiv  className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv p="10px 50px">
                <Paragraph ta="center"  fm="PoppinsSB">
                Taxes
                  </Paragraph>
                  <Paragraph ta="center" fs="24px"  fm="PoppinsSB">
                  4/4
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem item xs={10} sm={6} md={4} sx={{display:"flex",flexDirection:"column"}}  data-aos="fade-up">
            <ContractDiv>
            <Paragraph ta="center"  fs="16px" fm="PoppinsSB">
                CA:
                  </Paragraph>
                  <Paragraph wb="break-all" ta="right" fs="14px" fm="PoppinsSB">
                TBA
                  </Paragraph>
            </ContractDiv>
            <ContractDiv b="none">
            <Paragraph  fs="16px" fm="PoppinsSB">
            Lp Lock:
                  </Paragraph>
                  <a href="#tokenomics">
                  <Paragraph color="#0080FF" ta="right" fs="16px"  fm="PoppinsSB" sx={{textDecoration:"underline"}}>
                  View Lock Transaction
                  </Paragraph></a>
            </ContractDiv>
            <ContractDiv  b="none">
            <Paragraph fs="16px" fm="PoppinsSB">
            CA Renounce:
                  </Paragraph>
                  <a  href="#tokenomics"><Paragraph  color="#0080FF" ta="right" fs="16px"  fm="PoppinsSB"  sx={{textDecoration:"underline"}}>
                    View Renounce Transaction
                  </Paragraph></a>
            </ContractDiv>
          </GridItem>
        </GridWraper>
      </Container>
    </ContinerWraper>
  );
};

export default TokenomicsSection;
